/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Actions from './Actions/index'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/SlotDialog/Content",
  onClose
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let slotDialogViewValueData = fromData.useDataValue({ viewPath,
context: 'slot_dialog',
path: 'view',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: slotDialogViewValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Actions'}>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 onClose={onClose}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}